import React from 'react'
import { StatusCellStyles } from './Style'
import { Chip } from 'components/Form'
import { statuses } from 'keys'

const StatusCell = (props) => {
    const { role_name, sub_status, status } = props.row.original
    const { redo, inProgress, recheckPending, wordsInProgress } = statuses

    let statusItem = {
        label: 'ממתין לסימון',
        color: "thirdly"
    }

    if (status == inProgress && sub_status == wordsInProgress)
        statusItem = {
            label: "בסימון",
            color: "gray"
        }

    else if (status == inProgress && sub_status == recheckPending) {
        statusItem = {
            label: "ממתין לבקרה",
            color: "secondary"
        }
    }

    else if (status == redo && sub_status == recheckPending) {
        statusItem = {
            label: "ממתין לבקרה",
            color: "secondary"
        }
    }

    return (
        <StatusCellStyles>
            <Chip color={statusItem.color}>
                {statusItem.label} {!role_name || `- ${role_name}`}
            </Chip>
        </StatusCellStyles>
    )
}

export default StatusCell